export const SDK_EVENT_KEYS = {
    SdkStart: "SdkStart",
    GetConfigStart: "GetConfigStart",
    GetConfigSuccess: "GetConfigSuccess",
    GetConfigError: "GetConfigError",
    SdkResponseSuccess: "SdkResponseSuccess",
    SdkResponseError: "SdkResponseError",
    InitServiceLiveness: "InitServiceLiveness",
    InitServiceCardCapture: "InitServiceCardCapture",
    GetUIConfigInit: "GetUIConfigInit",
    GetUIConfigSuccess: "GetUIConfigSuccess",
    GetUIConfigError: "GetUIConfigError",
    SetUIConfiguration: "SetUIConfiguration",
    InitConfigCamera: "InitConfigCamera",
    ConfigCameraError: "ConfigCameraError",
    ConfigCameraSuccess: "ConfigCameraSuccess",
    ApplyConstraints: "ApplyConstraints",
    GetCameraPermissions: "GetCameraPermissions",
    GetCameraPermissionsSuccess: "GetCameraPermissionsSuccess",
    GetCameraPermissionsDenied: "GetCameraPermissionsDenied",
    GetCameraPermissionsError: "GetCameraPermissionsError",
    VirtualCameraValidation: "VirtualCameraValidation",
    VirtualCameraFound: "VirtualCameraFound",
    VirtualCameraNotFound: "VirtualCameraNotFound",
    VirtualCameraValidationEnd: "VirtualCameraValidationEnd",
    VirtualCameraError: "VirtualCameraError",
    InitGetBestCamera: "InitGetBestCamera",
    ListBestCamera: "ListBestCamera",
    SelectedBestCamera: "SelectedBestCamera",
    EndGetBestCamera: "EndGetBestCamera",
    ServiceCameraOpen: "ServiceCameraOpen",
    NoCameraFound: "NoCameraFound",
    InitConfigValues: "InitConfigValues",
    ApplyConfigValue: "ApplyConfigValue",
    ApplyConfigError: "ApplyConfigError",
    InitShowGuide: "InitShowGuide",
    EndShowGuide: "EndShowGuide",
    InitDetection: "InitDetection",
    CaptureFrame: "CaptureFrame",
    FrameToBase64: "FrameToBase64",
    FrameSend: "FrameSend",
    FrameSuccess: "FrameSuccess",
    FrameError: "FrameError",
    QualityCheck: "QualityCheck",
    IsAlive: "IsAlive",
    IsNotAlive: "IsNotAlive",
    Timeout: "Timeout",
    EndDetection: "EndDetection",
    SendToHost: "SendToHost",
    ResponseReceive: "ResponseReceive",

    CardCaptureInitCaptureManual: 'CardCaptureInitCaptureManual',
    CardCaptureTakePhoToManual: 'CardCaptureTakePhoToManual',
    SignImage: 'SignImage',
    ImageSigned: "ImageSigned",
    InitValidateSignature: "InitValidateSignature",
    EndValidateSignature: "EndValidateSignature",
    FailedValidateSignature: "FailedValidateSignature",
    CameraQualityDetected: 'CameraQualityDetected',
    ServiceResponseQuality: 'ServiceResponseQuality'
};

export const sdkEvents = {
    [SDK_EVENT_KEYS.SdkStart]: "Inicio del SDK de Liveness.",
    [SDK_EVENT_KEYS.GetConfigStart]: "Inicio de la obtención de la configuración del SDK.",
    [SDK_EVENT_KEYS.GetConfigSuccess]: "Configuración obtenida exitosamente.",
    [SDK_EVENT_KEYS.GetConfigError]: "Error al obtener la configuración (en caso de fallo).",
    [SDK_EVENT_KEYS.SdkResponseSuccess]: "Respuesta correcta del SDK.",
    [SDK_EVENT_KEYS.SdkResponseError]: "Respuesta con error del SDK.",
    [SDK_EVENT_KEYS.InitServiceLiveness]: "Inicialización del servicio de Liveness.",
    [SDK_EVENT_KEYS.InitServiceCardCapture]: "Inicialización del servicio de Card capture. {{type}}",
    [SDK_EVENT_KEYS.GetUIConfigInit]: "Inicio de la obtención de la configuración de UI.",
    [SDK_EVENT_KEYS.GetUIConfigSuccess]: "Configuración de UI obtenida correctamente.",
    [SDK_EVENT_KEYS.GetUIConfigError]: "Error al obtener la configuración de UI.",
    [SDK_EVENT_KEYS.SetUIConfiguration]: "Aplicación de la configuración de UI.",
    [SDK_EVENT_KEYS.InitConfigCamera]: "Inicio de la configuración de cámara.",
    [SDK_EVENT_KEYS.ConfigCameraError]: "Error al configurar la cámara.",
    [SDK_EVENT_KEYS.ConfigCameraSuccess]: "Cámara configurada correctamente.",
    [SDK_EVENT_KEYS.ApplyConstraints]: "Aplicación de restricciones/capacidades de la cámara.",
    [SDK_EVENT_KEYS.GetCameraPermissions]: "Solicitud de permisos de cámara.",
    [SDK_EVENT_KEYS.GetCameraPermissionsSuccess]: "Permisos de cámara concedidos.",
    [SDK_EVENT_KEYS.GetCameraPermissionsDenied]: "Permisos de cámara denegados.",
    [SDK_EVENT_KEYS.GetCameraPermissionsError]: "Error al solicitar permisos de cámara.",
    [SDK_EVENT_KEYS.VirtualCameraValidation]: "Validación de cámara virtual.",
    [SDK_EVENT_KEYS.VirtualCameraFound]: "Cámara virtual detectada.",
    [SDK_EVENT_KEYS.VirtualCameraNotFound]: "No se detectó cámara virtual.",
    [SDK_EVENT_KEYS.VirtualCameraValidationEnd]: "Fin de la validación de cámara virtual.",
    [SDK_EVENT_KEYS.VirtualCameraError]: "Error en la validación de cámara virtual.",
    [SDK_EVENT_KEYS.InitGetBestCamera]: "Inicio de selección de la mejor cámara.",
    [SDK_EVENT_KEYS.ListBestCamera]: "Listado de cámaras candidatas: {{cameras}}",
    [SDK_EVENT_KEYS.SelectedBestCamera]: "Cámara óptima seleccionada: {{camera}}",
    [SDK_EVENT_KEYS.EndGetBestCamera]: "Fin de la selección de cámara.",
    [SDK_EVENT_KEYS.ServiceCameraOpen]: "Apertura del servicio de cámara.",
    [SDK_EVENT_KEYS.NoCameraFound]: "No se encontró cámara disponible.",
    [SDK_EVENT_KEYS.InitConfigValues]: "Inicialización de valores de configuración.",
    [SDK_EVENT_KEYS.ApplyConfigValue]: "Aplicación de valor de configuración.",
    [SDK_EVENT_KEYS.ApplyConfigError]: "Error al aplicar valor de configuración.",
    [SDK_EVENT_KEYS.InitShowGuide]: "Inicio de guía visual para el usuario.",
    [SDK_EVENT_KEYS.EndShowGuide]: "Fin de la guía visual.",
    [SDK_EVENT_KEYS.InitDetection]: "Inicio de la detección/captura.",
    [SDK_EVENT_KEYS.CaptureFrame]: "Captura de frame.",
    [SDK_EVENT_KEYS.FrameToBase64]: "Conversión del frame a Base64.",
    [SDK_EVENT_KEYS.FrameSend]: "Envío del frame al servicio.",
    [SDK_EVENT_KEYS.FrameSuccess]: "Frame procesado correctamente.",
    [SDK_EVENT_KEYS.FrameError]: "Error al procesar el frame: {{error}}",
    [SDK_EVENT_KEYS.IsAlive]: "Resultado de liveness: Genuino (Alive).",
    [SDK_EVENT_KEYS.QualityCheck]: "Validación de calidad de imagen (iluminación, enfoque, oclusiones).",
    [SDK_EVENT_KEYS.IsNotAlive]: "Resultado de liveness: No genuino (Not Alive).",
    [SDK_EVENT_KEYS.Timeout]: "Tiempo de espera agotado.",
    [SDK_EVENT_KEYS.EndDetection]: "Fin de la detección.",
    [SDK_EVENT_KEYS.SendToHost]: "Envío de respuesta al host.",
    [SDK_EVENT_KEYS.ResponseReceive]: "Host recibió la respuesta.",
    [SDK_EVENT_KEYS.CardCaptureInitCaptureManual]: "Ha entrado en captura manual.",
    [SDK_EVENT_KEYS.CardCaptureTakePhoToManual]: "El usuario a tomado una foto manual",
    [SDK_EVENT_KEYS.SignImage]: "Iniciando proceso de firmado de imagen",
    [SDK_EVENT_KEYS.ImageSigned]: "Finalizo proceso de firmado de imagen",
    [SDK_EVENT_KEYS.InitValidateSignature]: "Iniciando proceso de validación de firma de imagen",
    [SDK_EVENT_KEYS.EndValidateSignature]: "Finalizó proceso de validación de firma de imagen",
    [SDK_EVENT_KEYS.FailedValidateSignature]: "La firma de la imagen no es valida",
    [SDK_EVENT_KEYS.CameraQualityDetected]: "{{data}}",
    [SDK_EVENT_KEYS.ServiceResponseQuality]: "{{data}}",
};



/**
 * Función para reportar eventos a un endpoint específico
 * Basada en el patrón del LogsSDK pero simplificada para casos específicos
 * Ahora incluye funcionalidad de cola de eventos para procesamiento secuencial
 */

class EventReporter {
    static instance = null

    eventQueue = []
    isProcessingQueue = false

    static getInstance() {
        if (!EventReporter.instance) {
            EventReporter.instance = new EventReporter()
        }
        return EventReporter.instance
    }

    /**
     * Añade un evento a la cola y lo procesa secuencialmente
     */
    async reportEvent(url, processId, eventType, message, processType = "CardCapture") {
        return new Promise((resolve, reject) => {
            this.eventQueue.push({
                params: { url, processId, eventType, message, processType },
                resolve,
                reject,
            })
            this.processEventQueue()
        })
    }

    /**
     * Procesa la cola de eventos secuencialmente
     */
    async processEventQueue() {
        if (this.isProcessingQueue || this.eventQueue.length === 0) return

        this.isProcessingQueue = true

        while (this.eventQueue.length > 0) {
            const { params, resolve, reject } = this.eventQueue.shift()

            try {
                const result = await this.sendEvent(params)
                resolve(result)
            } catch (error) {
                reject(error)
            }
        }

        this.isProcessingQueue = false
    }

    /**
     * Envía el evento al endpoint
     */
    async sendEvent(params) {
        const { url, processId, eventType, message, processType } = params

        // Validar parámetros requeridos
        if (!url) throw new Error("URL is required")
        if (!processId) throw new Error("ProcessId is required")
        if (!eventType) throw new Error("EventType is required")
        if (!message) throw new Error("Message is required")
        if (!processType) throw new Error("ProcessType is required")

        // Crear FormData con los parámetros
        const formdata = new FormData()
        formdata.append("ProcessId", processId)
        formdata.append("EventType", eventType)
        formdata.append("Message", message)
        formdata.append("ProcessType", processType)

        // Configurar opciones de la petición
        const requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow",
        }

        try {
            // Realizar la petición
            const response = await fetch(`${url}ReportEvent`, requestOptions)

            // Verificar si la respuesta es exitosa
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`)
            }

            return await response.text()
        } catch (error) {
            throw new Error(`Failed to report event: ${error instanceof Error ? error.message : "Unknown error"}`)
        }
    }

    /**
     * Obtiene el número de eventos pendientes en la cola
     */
    getPendingEventsCount() {
        return this.eventQueue.length
    }

    /**
     * Verifica si la cola está siendo procesada
     */
    isProcessing() {
        return this.isProcessingQueue
    }

    /**
     * Limpia la cola de eventos
     */
    clearQueue() {
        this.eventQueue = []
        this.isProcessingQueue = false
    }
}

// Instancia singleton del reporter
const eventReporter = EventReporter.getInstance()

/**
 * Función principal para reportar eventos
 * Se puede llamar múltiples veces de forma síncrona y garantiza procesamiento secuencial
 *
 * @param {string} url - URL del servidor
 * @param {string} processId - ID del proceso
 * @param {string} eventType - Tipo de evento
 * @param {string} message - Mensaje del evento
 * @returns {Promise} Promise que se resuelve cuando el evento se procesa
 */
export function reportEvent(url, processId, eventType, message) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await eventReporter.reportEvent(url, processId, eventType, message)
            resolve(result)
        } catch (e) {
            reject(e)
        }
    })
}

export function reportEventQueue(url, processId, eventType, params, processType) {
    // console.log(getEvent("ListBestCamera", { cameras: "Cam1, Cam2, Cam3" }));
    /*
    { eventType: 'ListBestCamera', description: 'Listado de cámaras candidatas: Cam1, Cam2, Cam3' }
    */
    const event = getEvent(eventType, params)
    return eventReporter.reportEvent(url, processId, event.eventType, event.description, processType)
}

/**
 * Versión con async/await más moderna (alternativa) - también usa cola
 */
export async function reportEventAsync(url, processId, eventType, message) {
    return eventReporter.reportEvent(url, processId, eventType, message)
}

/**
 * Versión que acepta un objeto con parámetros
 */
export function reportEventWithParams(params) {
    return reportEvent(params.url, params.processId, params.eventType, params.message)
}

export function getPendingEventsCount() {
    return eventReporter.getPendingEventsCount()
}

export function isProcessingQueue() {
    return eventReporter.isProcessing()
}

export function clearEventQueue() {
    eventReporter.clearQueue()
}
export function getEvent(eventType, params = {}) {
    let description = sdkEvents[eventType];
    if (!description) throw new Error(`Evento no válido: ${eventType}`);

    for (const [key, value] of Object.entries(params)) {
        description = description.replace(`{{${key}}}`, value);
    }

    return { eventType, description };
}

export { EventReporter }
